export enum MailingSplitTestWinnerTypeEnum {
  ClickRate = 'clickRate',
  OpenRate = 'openRate',
}

export const mailingSplitTestWinnerLocoKeys: Record<MailingSplitTestWinnerTypeEnum, string> = {
  [MailingSplitTestWinnerTypeEnum.ClickRate]:
    'dashboard.newsletter_editor.split_test.determinate.click_rate',
  [MailingSplitTestWinnerTypeEnum.OpenRate]:
    'dashboard.newsletter_editor.split_test.determinate.open_rate',
}
